/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { PrimaryButton } from 'components';
import {
  Typography,
} from '@mui/material';

import { useSelector } from 'react-redux';
import { UploadResponse, UploadScenarios } from 'interfaces/file-uploader';
import { PlusIcon } from 'assets/icons';
import { selectSponsorContent } from 'base/auth/selectors';
import { IUpdateProfileForm } from '../../interface';
import SponsorLogoUploader from './components/sponsor-logo-uploader';

const SponsorsLogoForm = () => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<IUpdateProfileForm>();
  const { fields, append, remove } = useFieldArray({ name: 'sponsors', control });

  const sponsorContent = useSelector(selectSponsorContent);
  const [sponsorContentUrls, setSponsorContentUrls] = React.useState<{
    url: string, action: string }[]>([]);

  const addSponsorLogo = () => {
    append({ url: '', contentUrl: '' });
    setSponsorContentUrls((prev) => [...prev, { url: '', action: '' }]);
  };

  const removeSponsorLogo = (index: number) => {
    remove(index);
    setSponsorContentUrls((prev) => prev.filter((_, i) => i !== index));
  };

  const handleInputChange = (index: number, input: string) => {
    setValue(`sponsors.${index}.contentUrl`, input);
    setSponsorContentUrls((prev) => {
      const updated = [...prev];
      updated[index].url = input;
      return updated;
    });
  };

  const handleUpload = (index: number, res: UploadResponse) => {
    setValue(`sponsors.${index}`, { url: res.url, contentUrl: '' });
  };

  React.useEffect(() => {
    remove();
    setSponsorContentUrls([]);
    sponsorContent?.forEach((sponsor) => {
      append({ url: sponsor.url, contentUrl: sponsor.contentUrl });
      setSponsorContentUrls((prev) => [...prev, { url: sponsor.contentUrl, action: '' }]);
    });
  }, [sponsorContent]);

  return (
    <>
      <div className="form-item">
        <Typography variant="h5" sx={{ mb: 2 }}>
          Sponsors
        </Typography>
      </div>
      <div className="row">
        {fields.map((item, i) => (
          <React.Fragment key={item.id}>
            <SponsorLogoUploader
              index={i}
              label={`Sponsor #${i + 1}`}
              imageLabel="Sponsor Logo"
              textFieldLabel="Sponsor URL"
              handleRemove={removeSponsorLogo}
              handleInputChange={handleInputChange}
              handleFile={handleUpload}
              scenario={UploadScenarios.expertSponsor}
              currentText={sponsorContentUrls[i]?.url || ''}
              currentImageUrl={fields[i]?.url || ''}
              errors={errors}
            />
          </React.Fragment>
        ))}
      </div>
      <PrimaryButton
        startIcon={<PlusIcon sx={{ color: '#fff' }} />}
        onClick={addSponsorLogo}
      >
        Add a new sponsor
      </PrimaryButton>
    </>
  );
};

export default SponsorsLogoForm;
